import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { TRAFFIC_FINE_SERVICE } from '../EndPoints';

/**
 * @Author      Jhovanny Fragoso Márquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

export const UpdateFineSettings = createAsyncThunk("fineType/updateFineSettings", async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(TRAFFIC_FINE_SERVICE.updateFineSettings, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});


export const getFineSettingsById = createAsyncThunk("fineType/getFineSettignsById", async ({ dispatch, getState }) => {

    const response = await apiInstance.get(TRAFFIC_FINE_SERVICE.getFineSettingsById).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
})